<div class="request-referral-wrapper">
	<form [formGroup]="specifyPreferencesForm">
		<div class="r-r-module provider">
			<div class="r-r-m-title">
				<h6 [translate]="'referral.request-referral.specify-preferences.provider.title'">Physician</h6>
			</div>
			<div class="r-r-module-content">
				<div class="row">
					<div class="col-md-6" formArrayName="location">
						<div class="r-row">
							<span class="col-form-label">
								<b [translate]="'referral.request-referral.specify-preferences.preferred-location.title'"
									>Preferred Location</b
								>
							</span>
						</div>
						<div class="r-row">
							<div *ngFor="let loc of locationArr; let ind = index" [formGroupName]="ind">
								<mat-checkbox [checked]="'true'" formControlName="locationSelected"
									>{{ loc.city }}, {{ loc.state }}
								</mat-checkbox>
								<span
									(click)="removeLocation(ind, loc)"
									class="text-link text-remove clickable"
									[translate]="'referral.request-referral.specify-preferences.preferred-location.remove'"
									appEheAnalytics
									[data]="analyticsData"
									>Remove</span
								>
							</div>
							<!-- <div class="error-msg" *ngIf="this.specifyPreferencesForm.get('location').errors">Pease select atleast one
								location</div> -->
							<app-error-message [control]="'location'" [top]="15"></app-error-message>
						</div>
						<div class="r-row" *ngIf="canAddNewLocation">
							<div
								(click)="addLocationDialog()"
								class="text-link clickable"
								[translate]="'referral.request-referral.specify-preferences.preferred-location.add-another'"
								appEheAnalytics
								[data]="analyticsData">
								Add another Location
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="outline">
							<div class="r-row">
								<span class="col-form-label">
									<b>
										<span class="required-marker">*</span
										><span [translate]="'referral.request-referral.specify-preferences.gender-preference.title'"
											>Physician Gender Preference</span
										></b
									>
								</span>
							</div>
							<div class="r-row position-relative">
								<mat-radio-group formControlName="genderPref">
									<mat-radio-button class="m-r-20" value="A"
										><span [translate]="'referral.request-referral.specify-preferences.gender-preference.any'"
											>Any</span
										></mat-radio-button
									>
									<mat-radio-button class="m-r-20" value="M"
										><span [translate]="'referral.request-referral.specify-preferences.gender-preference.male'"
											>Male</span
										></mat-radio-button
									>
									<mat-radio-button class="m-r-20" value="F"
										><span [translate]="'referral.request-referral.specify-preferences.gender-preference.female'"
											>Female</span
										></mat-radio-button
									>
									<app-error-message [control]="'genderPref'"></app-error-message>
								</mat-radio-group>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="r-r-module">
			<div class="r-r-m-title">
				<h6>
					<span class="required-marker">*</span
					><span [translate]="'referral.request-referral.specify-preferences.appointment.title'">Appointment</span>
				</h6>
			</div>
			<div class="r-r-module-content">
				<div class="row">
					<div class="col-md-12">
						<div class="r-row position-relative">
							<mat-radio-group formControlName="apptCordinationRequired">
								<mat-radio-button class="m-r-20" value="1" [disabled]="disabled"
									><span [translate]="'referral.request-referral.specify-preferences.appointment.appt-coordination.ehe'"
										>I would like EHE to schedule my appointment</span
									></mat-radio-button
								>
								<mat-radio-button class="m-r-20" value="2" [disabled]="disabled"
									><span [translate]="'referral.request-referral.specify-preferences.appointment.appt-coordination.own'"
										>I will schedule my appointment</span
									></mat-radio-button
								>
								<app-error-message [control]="'apptCordinationRequired'" [top]="12"></app-error-message>
							</mat-radio-group>
						</div>
					</div>
				</div>
				<div
					class="row"
					formArrayName="date_time"
					*ngIf="specifyPreferencesForm.get('apptCordinationRequired').value === '1'">
					<div class="col-md-12 mb-3">
						<app-error-message [control]="'date_time'"></app-error-message>
						<span [translate]="'referral.request-referral.specify-preferences.appointment.date-time.error'"
							>Please provide three preferred appointment dates and times ranges</span
						>
						<!-- <div class="error-msg" *ngIf="this.specifyPreferencesForm.get('date_time').errors">Pease select at least one date
							and time</div> -->
					</div>
					<ng-container *ngFor="let i of sliderArr" [formGroupName]="i">
						<div class="col-md-4">
							<div class="row">
								<div class="col-md-12">
									<mat-form-field class="full-width">
										<input
											matInput
											[matDatepicker]="picker1"
											name="{{
												'referral.request-referral.specify-preferences.appointment.preferred-date' | translate
											}}"
											formControlName="date"
											[min]="minDate"
											placeholder="{{ 'referral.request-referral.specify-preferences.date' | translate }}" />
										<mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
										<mat-datepicker #picker1></mat-datepicker>
										<!-- <mat-error>
											<app-error-message [control]="'date'"></app-error-message>
										</mat-error> -->
									</mat-form-field>
								</div>
							</div>
						</div>
						<div class="col-md-8">
							<div class="row">
								<div class="col-md-12">
									<ngx-slider
										[(value)]="sliderTime[i].value"
										[(highValue)]="sliderTime[i].highValue"
										[options]="options"></ngx-slider>
								</div>
							</div>
						</div>
					</ng-container>
				</div>
				<div>
					<mat-form-field appearance="outline" class="full-width mt-3">
						<textarea
							matInput
							cdkTextareaAutosize
							cdkAutosizeMinRows="3"
							placeholder="{{ 'referral.request-referral.specify-preferences.notes' | translate }}"
							formControlName="notes"></textarea>
						<mat-error>
							<app-error-message [control]="'notes'"></app-error-message>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
		</div>

		<div class="r-r-module" *ngIf="specifyPreferencesForm.get('apptCordinationRequired').value === '1'">
			<div class="r-r-m-title">
				<h6 [translate]="'referral.request-referral.specify-preferences.record-transfer.title'">
					Medical Record Transfer
				</h6>
			</div>

			<div class="r-r-module-content">
				<div class="row">
					<div class="col-md-12 mb-0">
						<div class="r-row l-h">
							<mat-checkbox formControlName="transferEheRecords"
								><span [translate]="'referral.request-referral.specify-preferences.record-transfer.transfer-records'"
									>Please transfer my EHE exam records to physicians</span
								></mat-checkbox
							>
							<mat-error>
								<app-error-message [control]="'transferEheRecords'" [top]="20"></app-error-message>
							</mat-error>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="r-r-module">
			<div class="r-r-m-title">
				<h6>Insurance Information</h6>
			</div>

			<div class="r-r-module-content" formGroupName="insurance">
				<div class="row">
					<div class="col-md-6">
						<div class="form-group row" *ngIf="checkSpecialty(2)">
							<span class="col-sm-5 col-form-label">
								<span [translate]="'referral.request-referral.specify-preferences.insurance.form.plan-name'"
									>Plan name</span
								><span class="required-marker">*</span></span
							>
							<div class="col-sm-7">
								<mat-form-field class="full-width">
									<mat-select disableOptionCentering panelClass="custom-material-position" formControlName="planId">
										<mat-option value="" disabled selected>{{
											'referral.request-referral.specify-preferences.insurance.form.plan-name' | translate
										}}</mat-option>
										<mat-option *ngFor="let name of planName | insuranceFilter: medicalFilter" [value]="name.id">{{
											name?.name
										}}</mat-option>
									</mat-select>
									<!-- <mat-error>
										<app-error-message [control]="'planId'"></app-error-message>
									</mat-error> -->
								</mat-form-field>
							</div>
						</div>

						<div class="form-group row">
							<span class="col-sm-5 col-form-label">
								<span [translate]="'referral.request-referral.specify-preferences.insurance.form.group-number'"
									>Group Number</span
								><span class="required-marker">*</span></span
							>
							<div class="col-sm-7">
								<mat-form-field class="full-width">
									<input
										matInput
										placeholder="{{
											'referral.request-referral.specify-preferences.insurance.form.group-number' | translate
										}}"
										formControlName="groupNumber" />
									<!-- <mat-error>
										<app-error-message [control]="'groupMember'"></app-error-message>
									</mat-error> -->
								</mat-form-field>
							</div>
						</div>

						<div class="form-group row" *ngIf="checkSpecialty(2) && showPlanNameOther">
							<span class="col-sm-5 col-form-label">
								<span class="required-marker">*</span
								><span [translate]="'referral.request-referral.specify-preferences.insurance.form.plan-name-other'"
									>Plan Name Other</span
								></span
							>
							<div class="col-sm-7">
								<mat-form-field class="full-width">
									<input
										matInput
										name="{{
											'referral.request-referral.specify-preferences.insurance.form.plan-name-other' | translate
										}}"
										formControlName="planNameOther" />
									<!-- <mat-error>
										<app-error-message [control]="'memberId'"></app-error-message>
									</mat-error> -->
								</mat-form-field>
							</div>
						</div>

						<div class="form-group row" *ngIf="checkSpecialty(1)">
							<span class="col-sm-5 col-form-label">
								<span class="required-marker">*</span
								><span [translate]="'referral.request-referral.specify-preferences.insurance.form.dental-plan-name'"
									>Dental Plan name</span
								></span
							>
							<div class="col-sm-7">
								<mat-form-field class="full-width">
									<mat-select
										disableOptionCentering
										panelClass="custom-material-position"
										formControlName="dentalPlanId">
										<mat-option value="" disabled selected>{{
											'referral.request-referral.specify-preferences.insurance.form.dental-plan-name' | translate
										}}</mat-option>
										<mat-option *ngFor="let name of planName | insuranceFilter: dentalFilter" [value]="name.id">{{
											name?.name
										}}</mat-option>
									</mat-select>
									<!-- <mat-error>
										<app-error-message [control]="'dentalPlanId'"></app-error-message>
									</mat-error> -->
								</mat-form-field>
							</div>
						</div>
						<div class="form-group row" *ngIf="checkSpecialty(1) && showDentalNameOther">
							<span class="col-sm-5 col-form-label">
								<span class="required-marker">*</span
								><span
									[translate]="'referral.request-referral.specify-preferences.insurance.form.dental-plan-name-other'"
									>Dental Plan Name Other</span
								></span
							>
							<div class="col-sm-7">
								<mat-form-field class="full-width">
									<input
										matInput
										name="{{
											'referral.request-referral.specify-preferences.insurance.form.plan-name-other' | translate
										}}"
										formControlName="dentalPlanNameOther" />
									<!-- <mat-error>
										<app-error-message [control]="'memberId'"></app-error-message>
									</mat-error> -->
								</mat-form-field>
							</div>
						</div>
						<div class="form-group row" *ngIf="checkSpecialty(3)">
							<span class="col-sm-5 col-form-label">
								<span class="required-marker">*</span
								><span [translate]="'referral.request-referral.specify-preferences.insurance.form.vision-plan-name'"
									>Vision Plan name</span
								></span
							>
							<div class="col-sm-7">
								<mat-form-field class="full-width">
									<mat-select
										disableOptionCentering
										panelClass="custom-material-position"
										formControlName="visionPlanId">
										<mat-option value="" disabled selected>{{
											'referral.request-referral.specify-preferences.insurance.form.vision-plan-name' | translate
										}}</mat-option>
										<mat-option *ngFor="let name of planName | insuranceFilter: visionFilter" [value]="name.id">{{
											name?.name
										}}</mat-option>
									</mat-select>
									<!-- <mat-error>
										<app-error-message [control]="'visionPlanId'"></app-error-message>
									</mat-error> -->
								</mat-form-field>
							</div>
						</div>
						<div class="form-group row" *ngIf="checkSpecialty(3) && showVisionNameOther">
							<span class="col-sm-5 col-form-label">
								<span class="required-marker">*</span
								><span
									[translate]="'referral.request-referral.specify-preferences.insurance.form.vision-plan-name-other'"
									>Vision Plan Name Other</span
								></span
							>
							<div class="col-sm-7">
								<mat-form-field class="full-width">
									<input
										matInput
										name="{{
											'referral.request-referral.specify-preferences.insurance.form.vision-plan-name-other' | translate
										}}"
										formControlName="visionPlanNameOther" />
									<!-- <mat-error>
										<app-error-message [control]="'memberId'"></app-error-message>
									</mat-error> -->
								</mat-form-field>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group row" *ngIf="checkSpecialty(2)">
							<span class="col-sm-5 col-form-label">
								<span [translate]="'referral.request-referral.specify-preferences.insurance.form.plan-type'"
									>Plan Type</span
								><span class="required-marker">*</span></span
							>
							<div class="col-sm-7">
								<mat-form-field class="full-width">
									<mat-select disableOptionCentering panelClass="custom-material-position" formControlName="planTypeId">
										<mat-option value="" disabled selected>{{
											'referral.request-referral.specify-preferences.insurance.form.plan-type' | translate
										}}</mat-option>
										<mat-option *ngFor="let type of planType | insuranceFilter: medicalFilter" [value]="type.id">{{
											type?.name
										}}</mat-option>
									</mat-select>
									<!-- <mat-error>
										<app-error-message [control]="'planTypeId'"></app-error-message>
									</mat-error> -->
								</mat-form-field>
							</div>
						</div>

						<div class="form-group row">
							<span class="col-sm-5 col-form-label">
								<span [translate]="'referral.request-referral.specify-preferences.insurance.form.member-id'"
									>Member ID</span
								><span class="required-marker">*</span></span
							>
							<div class="col-sm-7">
								<mat-form-field class="full-width">
									<input
										matInput
										placeholder="{{
											'referral.request-referral.specify-preferences.insurance.form.member-id' | translate
										}}"
										formControlName="memberId" />
									<!-- <mat-error>
										<app-error-message [control]="'memberId'"></app-error-message>
									</mat-error> -->
								</mat-form-field>
							</div>
						</div>

						<div class="form-group row" *ngIf="checkSpecialty(2) && showPlanTypeOther">
							<span class="col-sm-5 col-form-label">
								<span class="required-marker">*</span
								><span [translate]="'referral.request-referral.specify-preferences.insurance.form.plan-type-other'"
									>Plan Type Other</span
								></span
							>
							<div class="col-sm-7">
								<mat-form-field class="full-width">
									<input
										matInput
										name="Plan Type Other"
										formControlName="{{
											'referral.request-referral.specify-preferences.insurance.form.plan-type-other' | translate
										}}" />
									<!-- <mat-error>
										<app-error-message [control]="'memberId'"></app-error-message>
									</mat-error> -->
								</mat-form-field>
							</div>
						</div>
						<div class="form-group row" *ngIf="checkSpecialty(1)">
							<span class="col-sm-5 col-form-label">
								<span class="required-marker">*</span
								><span [translate]="'referral.request-referral.specify-preferences.insurance.form.dental-plan-type'"
									>Dental Plan Type</span
								></span
							>
							<div class="col-sm-7">
								<mat-form-field class="full-width">
									<mat-select
										disableOptionCentering
										panelClass="custom-material-position"
										formControlName="dentalPlanTypeId">
										<mat-option value="" disabled selected>{{
											'referral.request-referral.specify-preferences.insurance.form.dental-plan-type' | translate
										}}</mat-option>
										<mat-option *ngFor="let name of planType | insuranceFilter: dentalFilter" [value]="name.id">{{
											name?.name
										}}</mat-option>
									</mat-select>
									<!-- <mat-error>
										<app-error-message [control]="'dentalPlanType'"></app-error-message>
									</mat-error> -->
								</mat-form-field>
							</div>
						</div>
						<div class="form-group row" *ngIf="checkSpecialty(1) && showDentalTypeOther">
							<span class="col-sm-5 col-form-label">
								<span class="required-marker">*</span
								><span
									[translate]="'referral.request-referral.specify-preferences.insurance.form.dental-plan-type-other'"
									>Dental Plan Type Other</span
								></span
							>
							<div class="col-sm-7">
								<mat-form-field class="full-width">
									<input
										matInput
										name="{{
											'referral.request-referral.specify-preferences.insurance.form.dental-plan-name-other' | translate
										}}"
										formControlName="dentalPlanTypeOther" />
									<!-- <mat-error>
										<app-error-message [control]="'memberId'"></app-error-message>
									</mat-error> -->
								</mat-form-field>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="r-row">
							<mat-checkbox formControlName="outOfNetwork"
								><span [translate]="'referral.request-referral.specify-preferences.out-of-network'"
									>I am willing to see a physician who does not participate with my health insurance plan</span
								></mat-checkbox
							>
							<mat-error>
								<app-error-message [control]="'outOfNetwork'"></app-error-message>
							</mat-error>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="r-r-module">
			<div class="r-r-module-content">
				<div class="row referral-checkbox">
					<div class="col-md-12">
						<div class="r-row mb-3">
							<mat-checkbox formControlName="patientConsentProvided">
								<span [translate]="'referral.request-referral.specify-preferences.consent'">
									I do hereby authorize EHE to release my protected health information, including copies of my medical
									records that are related to care received during my EHE Health preventative care exam to the following
									person(s) at the location/facility checked above (or below) for the purpose(s) as indicated above.
								</span>
							</mat-checkbox>
							<mat-error>
								<app-error-message [control]="'patientConsentProvided'"></app-error-message>
							</mat-error>
						</div>
					</div>
				</div>
				<div class="row">
					<p>
						<b [translate]="'referral.request-referral.specify-preferences.terms'">
							By submitting this form, I agree to the following:
						</b>
						<span [translate]="'referral.request-referral.specify-preferences.terms-description'">
							As clinically recommended, EHE will identify health care physician, coordinate appointments (if
							requested), and transfer medical records, where appropriate. EHE will provide these administrative
							services at no cost to me, but I understand that I remain personally responsible for any and all
							co-payments, co-insurance, and/or full payments to the referred health care physician(s). I further
							understand this is an elective option for further medical services, and that I remain personally
							responsible for seeking additional medical care as may be recommended by my EHE physician and/or EHE
						</span>
					</p>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-12">
				<button mat-stroked-button matStepperPrevious class="button">
					<span [translate]="'referral.request-referral.stepper.back-button'">Back</span>
				</button>
				<button mat-button appEheAnalytics [data]="analyticsData" class="button" (click)="submitReferralInfo()">
					<span [translate]="'referral.request-referral.stepper.submit-button'">Submit</span>
				</button>
				<button mat-stroked-button appEheAnalytics [data]="analyticsData" class="button" (click)="cancel()">
					<span [translate]="'referral.request-referral.stepper.cancel-button'">Cancel</span>
				</button>
			</div>
		</div>
	</form>
</div>
